export const LOAD_SIMULATOR_ASSET_STARTED = "LOAD_SIMULATOR_ASSET_STARTED";
export const LOAD_SIMULATOR_ASSET_SUCCEEDED = "LOAD_SIMULATOR_ASSET_SUCCEEDED";
export const LOAD_SIMULATOR_ASSET_FAILED = "LOAD_SIMULATOR_ASSET_FAILED";
export const RESET_SIMULATOR_ASSETS = "RESET_SIMULATOR_ASSETS";

export const SAVE_OFFER_FROM_SIMULATOR_STARTED = "SAVE_OFFER_FROM_SIMULATOR_STARTED";
export const SAVE_OFFER_FROM_SIMULATOR_SUCCEEDED = "SAVE_OFFER_FROM_SIMULATOR_SUCCEEDED";
export const SAVE_OFFER_FROM_SIMULATOR_FAILED = "SAVE_OFFER_FROM_SIMULATOR_FAILED";

export const LOAD_SIMULATOR_PRODUCTS_STARTED = "LOAD_SIMULATOR_PRODUCTS_STARTED";
export const LOAD_SIMULATOR_PRODUCTS_SUCCEEDED = "LOAD_SIMULATOR_PRODUCTS_SUCCEEDED";
export const LOAD_SIMULATOR_PRODUCTS_FAILED = "LOAD_SIMULATOR_PRODUCTS_FAILED";
